import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sturm-customer-table',
  templateUrl: './customer-table.component.html',
  styleUrls: ['./customer-table.component.scss']
})
export class CustomerTableComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
